import ColorPicker from '../ui/ColorPicker';
import type { ThemeColor } from '../../types/theme';

interface ThemeSelectorProps {
  currentColor: ThemeColor;
  useSystemColor: boolean;
  onColorChange: (color: ThemeColor) => void;
  onSystemColorChange: (checked: boolean) => void;
}

function ThemeSelector({
  currentColor,
  useSystemColor,
  onColorChange,
  onSystemColorChange,
}: ThemeSelectorProps) {
  return (
    <ColorPicker
      currentColor={currentColor}
      useSystemColor={useSystemColor}
      onColorChange={onColorChange}
      onSystemColorChange={onSystemColorChange}
      toggle="switch"
    />
  );
}

export default ThemeSelector;
